<app-header></app-header>
<app-sidebar
  ativo="Gestao"
></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="Usuários"
      Pagina="Usuario"
    ></app-breadcrumb>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12">
            <div class="col-md-12 text-right" style="margin-bottom: 10px;">
              <a href="gestao/usuarios/novo"><button class="btn btn-primary"><i class="fa fa-plus"></i> Cadastrar</button></a>
            </div>
            <app-tabela titulo="Lista de usuários"
                        placeHolder="Buscar usuario"
                        [colunas]="colunas"
                        [linhas]="linhas"
                        [botaoEditar]= "botaoEditar"
                        linkBotaoEditar="gestao/conta"
            ></app-tabela>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
